import { isChromakeyModeActive } from 'src/utils/env'

import * as S from './styles'

export const WaitingForDocumentTemplate = () => (
    <S.TemplateContent>
        {!isChromakeyModeActive && <S.StyledTranscriptIcon />}
        <S.TemplateDescription>
            <div>The transcript will be displayed</div>
            <div>when the document is fully processed (the page will refresh automatically)</div>
        </S.TemplateDescription>
    </S.TemplateContent>
)
